import React from 'react'
import {Sparkles} from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 to-emerald-400 rounded-lg flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-slate-900" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">Triangle Project Consultants</h3>
                <p className="text-xs text-cyan-400">AI-Enhanced Solutions</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4">
              Expert project consulting services enhanced by AI technology to help organizations achieve strategic goals and drive business growth.
            </p>
            <div className="text-sm text-gray-500">
              <p>HUB Certified • NCSBE Certified</p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-cyan-400 transition">AI Strategy</a></li>
              <li><a href="#" className="hover:text-cyan-400 transition">Project Management</a></li>
              <li><a href="#" className="hover:text-cyan-400 transition">Change Management</a></li>
              <li><a href="#" className="hover:text-cyan-400 transition">Data Analytics</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li>(919) 930-3059</li>
              <li>Raleigh, NC</li>
              <li className="pt-2">
                <a href="mailto:Triangleprojectconsultants@gmail.com" className="text-cyan-400 hover:text-cyan-300 transition">
                  Get in Touch
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            © 2025 Triangle Project Consultants. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500">
            <a href="#admin" className="hover:text-cyan-400 transition">Admin</a>
            <a href="#" className="hover:text-cyan-400 transition">Privacy Policy</a>
            <a href="#" className="hover:text-cyan-400 transition">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
